import React from "react";
import { Outlet } from "react-router-dom";
import HorizontalNavBar from "../../components/HorizontalNavBar";
import { regularData } from "../../navigation/horizontal";

const Regular = () => {
  return (
    <div className="subnavbartopdiv ">
      <HorizontalNavBar links={regularData} />
      <div className=" subnavbareachpart"><Outlet />
      </div>
    </div>
  );
};

export default Regular;
